/* OsCatalogSkusComponent.js */

"use strict";
// const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsCatalogSkusRenderer");
const _ = require("lodash");

class OsCatalogSkusComponent extends EventEmitter {
    constructor(osCatalogDetailsView) {
        super();
        this._osCatalogDetailsView = osCatalogDetailsView;
        this._gameEditor = osCatalogDetailsView.gameEditor;
        this._osCatalogEntity = this._gameEditor.getOsCatalog();
        this._deviceEntity = this._gameEditor.deviceEntity;
        this._activeOrgId = this._gameEditor.activeOrgId;
        this._logger = this._gameEditor._logger;
        this._regexPlaceholder = "/Insert your regular expression/gi";
        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._osCatalogEntity.on("DirtyStateChanged", (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this)));
    }

    _unregisterListeners() {
        this._osCatalogEntity.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get renderer() {
        return this._getRenderer();
    }

    _getRenderer() {
        return this._renderer;
    }

    get deviceEntity() {
        return this._getDeviceEntity();
    }

    _getDeviceEntity() {
        return this._deviceEntity;
    }

    get activeOrgId() {
        return this._getActiveOrgId();
    }

    _getActiveOrgId() {
        return this._activeOrgId;
    }

    getOsCatalogEntity() {
        return this._osCatalogEntity;
    }

    get osCatalogEntity() {
        return this.getOsCatalogEntity();
    }

    set osCatalogEntity(newCatalog) {
        this._osCatalogEntity = newCatalog;
        return true;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._osCatalogDetailsView = undefined;
                this._gameEditor = undefined;
                this._osCatalogEntity = undefined;
                this._deviceEntity = undefined;
                this._activeOrgId = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn(err, "OsCatalogSkusComponent.shutdown() error.");
            }
        );
    }

    updateSkus() {
        this._renderer._formsComponent.clearPendingPatches();
        this._renderer._formsComponent.setPristineValue(this.osCatalogEntity.getPristineProperties());
    }

    trimSkusRegexJunkValues() {
        let regexValues = this._renderer._formsComponent.getValue();
        let pristineValues = this._renderer._formsComponent.getPristineValue();
        const trimmedSkus = _.filter(regexValues.skus, (sku) => !_.isEmpty(sku.skusCol.trim()));
        let trimmedDefaultValueSkus = _.filter(trimmedSkus, (sku) => sku.skusCol !== this._regexPlaceholder);
        pristineValues.skus = trimmedDefaultValueSkus;
        this._renderer._formsComponent.setPristineValue(pristineValues);
        this.osCatalogEntity.setSkus(trimmedDefaultValueSkus);
        let isAllRegexValid = trimmedDefaultValueSkus.every((sku) => this.checkRegexpValidity(sku.skusCol));
        console.log(isAllRegexValid);
        if (isAllRegexValid) {
            return Promise.resolve();
        } else {
            return Promise.reject();
        }
    }

    checkRegexpValidity(strRegExp, silent) {
        if (strRegExp[0] !== "/") {
            strRegExp = "/" + strRegExp;
            if (!strRegExp.match(/^\/.+\/[gimy]*$/)) {
                strRegExp = strRegExp + "/";
            }
        }
        let parts = strRegExp.match(/^\/(.+)\/([gimy]*)$/);

        if (parts) {
            try {
                let objRegExp = new RegExp(parts[1], parts[2]);
                return objRegExp;
            } catch (e) {
                this._logger.warn({ error: e }, "OsCatalogSkusRenderer._getSkusRegexQuery() error: Invalid regular expression");
                if (!silent) {
                    this._osCatalogDetailsView._modalUserFeedback.displayError({
                        error: {
                            errorMsg: `The OS Catalog ${this._osCatalogEntity.getName()} contains at least one invalid regular expression.`
                        }
                    });
                    return false;
                }
            }
        } else {
            this._logger.warn({}, "OsCatalogSkusRenderer._getSkusRegexQuery() error: Invalid regular expression");
            if (!silent) {
                this._osCatalogDetailsView._modalUserFeedback.displayError({
                    error: {
                        errorMsg: `The OS Catalog ${this._osCatalogEntity.getName()} contains at least one invalid regular expression.`
                    }
                });
                return false;
            }
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDirtyStateChanged(dirtyState) {
        this.emit("Dirty", dirtyState);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}

module.exports = OsCatalogSkusComponent;
